module.exports = __webpack_public_path__ + "img/treatment_open_getting.9ee4379f.svg";